export default __webpack_public_path__ + "static/media/mobile-phone.3678e7fe.svg";